<script lang="ts">
  import { onMount, onDestroy } from 'svelte'
  import type { Snippet } from 'svelte'

  interface Props {
    title: string
    onclose: () => void
    children?: Snippet
  }

  const { title, onclose, children }: Props = $props()

  function handleKeydown(e: KeyboardEvent): void {
    if (e.key === 'Escape') onclose()
  }

  function handleBackdropClick(): void {
    onclose()
  }

  onMount(() => {
    document.addEventListener('keydown', handleKeydown)
  })
  onDestroy(() => {
    document.removeEventListener('keydown', handleKeydown)
  })
</script>

<div class="modal-backdrop" role="presentation" onclick={handleBackdropClick}>
  <div
    class="modal-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
    tabindex="-1"
    onclick={(e) => e.stopPropagation()}
    onkeydown={handleKeydown}
  >
    <header>
      <h2 id="modal-title">{title}</h2>
      <button type="button" class="modal-close" onclick={onclose} aria-label="Close">×</button>
    </header>
    <div class="modal-body">
      {#if children}
        {@render children()}
      {/if}
    </div>
  </div>
</div>

<style>
  .modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }
  .modal-dialog {
    background: var(--surface-2);
    border-radius: 8px;
    padding: 24px;
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  header h2 {
    margin: 0;
    font-size: 1.25rem;
  }
  .modal-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--muted);
  }
  .modal-close:hover {
    color: var(--ink-strong);
  }
</style>
